import { render, staticRenderFns } from "./DeleteBuildingConfirmation.vue?vue&type=template&id=eff192bc&"
import script from "./DeleteBuildingConfirmation.vue?vue&type=script&lang=js&"
export * from "./DeleteBuildingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports